const handleInterviewListFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.interviewList = action.payload.data.data;
  state.interviewReportsOrder = action.payload.data.data.map(interviewReport => interviewReport.id);
  state.currentPage = action.payload.data.current_page;
  state.perPage = action.payload.data.limit;
  state.totalPages = action.payload.data.last_page;
  state.totalInterviewReports = action.payload.data.total;
  state.lastUpdated = action.payload.data.last_updated;
  state.message = action.payload.message;
};

export {
  handleInterviewListFulfilled
};
